import React from 'react';
import { map } from 'lodash';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';
import searchQuery from 'query-string';

// local Dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { button as Button } from 'modules/button';
import { entityInfoCellView as EntityInfoCellView } from 'ui/views/widgets/entityInfoCellView';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
import { overlay } from 'modules/overlay';


/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { disableAutoRefill as DisableAutoRefill } from 'ui/views/widgets/disableAutoRefill';
 *
 * // render
 * <DisableAutoRefill propName='propValue'/>
 */
export const _disableAutoRefill = ( props ) => {

    const values = props.data.state.values;

    const onActionClick = ( { type, item } ) => {
        log.debug( 'disable.Routechange', type, item );

        if ( 'cell' === type && 'rxNumber' === item.name ) {
            
            overlay.close();

            props.history.push( {
                pathname: DASHBOARD_SUB_ROUTES.PRESCRIPTION_DETAIL,
                state: { ...props.backRouteState, memberId: props.payload.data.memberId },
                search: searchQuery.stringify( {
                    rxId: props.payload.data.rxId,
                } ),
            } );

        } else {
            overlay.close();
        }
    };

    return (
        <div className='ui-disable-auto-refill'>
			<div className='ui-disable-auto-refill__header'>
				{ /* title for the modal */ }
				<div className='ui-disable-auto-refill__header__title'>
					{ getLabel( props.title ) }
				</div>

				{ /* close button */ }
				<div
					className='ui-error-overlay__head__close'
					onClick={ () => props.closeOverlay() }
				>
					<Icon name='close' width='14' height='14' fill='#ffffff' />
				</div>
			</div>
            <div className='ui-disable-auto-refill__body'>

                <div className='ui-disable-auto-refill__body__description'>
                    { getLabel( props.description ) }
                </div>

                <div className='ui-disable-auto-refill__body__fields'>

					{ map( props.fields, field => {

                        const fieldClassName = classnames( 'ui-disable-auto-refill__body__fields__field', `ui-disable-auto-refill__body__fields__${field.name}` );

						return (
							<div key={ field.name } className={ fieldClassName } >
								
                                <EntityInfoCellView
                                    key={ field.name }
                                    item={ field }
                                    value={ values[ field.name ] }
                                    actionsVisibility={ props.data.state.actionsVisibility }
                                    className= 'ui-disable-auto-refill__body__fields__cell'
                                    onActionClick={ onActionClick }
                                    entityConfig={ field.actionConfig }
                                />
							</div>
						);
					} ) }

				</div>

                {/* button actions */}
				<div className='ui-disable-auto-refill__body__actions'>
					{ map( props.actions, action => {
						return (
							<Button
								key={ action.name }
								{ ...action }
								outline={ 'cancel' === action.name ? true: false }
								size='large'
								className='ui-disable-auto-refill__body__actions__action'
								onClick={ () => 'cancel' !== action.name ? props.onSumbitClick() : props.onCancelClick() }
							/>
						);
					} ) }
				</div>
            </div>
		</div>
    );
};

// set display name
_disableAutoRefill.displayName = 'disableAutoRefill';

// set default props
_disableAutoRefill.defaultProps = {};

// prop types
_disableAutoRefill.propTypes = {};


export const disableAutoRefill = withRouter( _disableAutoRefill );
